export const defaultStyle = {
  headerContainer: "engHeader headerContainer w-full text-center top-0 bg-white z-[101] h-[103px] md:h-[79px] fixed max-w-[1920px]",
  headerContent: "headerContent h-full px-[30px]",
  headerLogo: "headerLogo flex justify-between md:max-w-[1260px] xxl:max-w-[1280px] h-full items-center mx-auto",
  brandLogo: "relative float-left pl-20 lg:pl-15 lg:w-auto w-4/5",
  logoImgLink: "",
  logoImg: "max-w-full w-[221px] lg:w-[215px] lg:min-w-[214px] h-auto",
  logoWraperLink: "logoWraperLink lg:w-[21%] md:mx-20 lg:mx-0 md:pl-10 lg:pl-0",
  mainNavWrapper: "mainNavWrapper flex",
  searchboxStyles: {
    formContainer: `flex justify-between content-center z-[9999] overflow-hidden searchInput print-noshow absolute right-0 bg-white rounded-20 border-2 px-8 border-borderGrey py-[0.1rem] mr-[30px] cursor-pointer items-center`,
    form: "ml-[7px] w-full",
    image: "z-[9] lg:h-15 mt-[-7px]",
    input: "outline-none bg-transparent text-15 placeholder-darkBlue max-w-full z-5 placeholder-opacity-[0.5]",
  },
}

export const ENG_HEADER_NEW = {
  ...defaultStyle,
  headerContainer: "engHeader headerContainer w-full text-center top-0 bg-white z-[101] h-[103px] md:h-[79px] fixed max-w-[1920px]",
  headerContent: "headerContent h-full px-[30px]",
  headerLogo: "headerLogo flex justify-between md:max-w-[1260px] xxl:max-w-[1280px] h-full items-center mx-auto",
  brandLogo: "relative float-left pl-20 lg:pl-15 lg:w-auto w-4/5",
  logoImgLink: "logo-img-link",
  logoImg: "max-w-full w-[221px] lg:w-[215px] h-auto",
  logoWraperLink: "logoWraperLink lg:w-[21%] md:mx-20 lg:mx-0 md:pl-10 lg:pl-0",
  mainNavWrapper: "mainNavWrapper flex",
  searchboxStyles: {
    formContainer: `flex justify-between content-center z-[9999] overflow-hidden searchInput print-noshow absolute right-0 bg-white rounded-20 border-2 px-8 border-borderGrey py-[0.1rem] mr-[30px] cursor-pointer items-center`,
    form: "ml-[7px] w-full",
    image: "z-[9] lg:h-15 mt-[-7px]",
    input: "outline-none bg-transparent text-15 placeholder-darkBlue max-w-full z-5 placeholder-opacity-[0.5]",
  },
}